import DianZan from './lib/zan';

export default DianZan;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.dianzan.mobile/app/index.js